/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AxiosError } from 'axios';
import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { EventSessionsStatusResponse, EventSessionDetailsResponse } from 'models/viewModels';

class SessionApi {
  async getSessions(eventId: string): Promise<EventSessionsStatusResponse> {
    return new Promise<EventSessionsStatusResponse>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/session/eventSessionsStatus', { params: { eventId: eventId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }

  async getSession(eventId: string): Promise<EventSessionDetailsResponse | undefined> {
    const response = new Promise<EventSessionDetailsResponse>((resolve, reject) => {
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/session/sessionDetails', { params: { id: eventId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)));
    });
    return response;
  }

  async getRaceSessionByTrackEventId(trackEventId: string): Promise<EventSessionDetailsResponse> {
    const response = new Promise<EventSessionDetailsResponse>((resolve, reject) => {
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/session/sessionDetails', { params: { id: trackEventId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)));
    });
    return response;
  }
}

export const sessionApi = new SessionApi();
